<style>
  .DownLoaded{
    background-color:#ff9595 !important;
  }

  .Uploaded{
    background-color:#a595ff  !important;
  }

  .Certificate{
    background-color:#95ff9e  !important;
  }


</style>

<div class="col-md-12 mb-30">
  <div class="card card-statistics h-100">
    <div class="card-body">
     <h5 class="card-title border-0 pb-0">Collaborator Records</h5>
     <br/>
     <br>

      <div class="row">
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">Date Range</label>
          <select class="custom-select" [(ngModel)]="SubmitPeriodDate" name="SubmitPeriodDate">
            <option value="1">Apply</option>
            <option value="0">Do Not Apply</option>
          </select>
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">Start Date</label>
          <input type="text" #datepickerInputStart placeholder="Type here..."   class="form-control" />
          <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false" [dateFormat]="'jYYYY-jMM-jDD'" [input]="datepickerInputStart"></ng-persian-datepicker>
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">End Date</label>
          <input type="text" #datepickerInputEnd  placeholder="Type here..."  class="form-control" />
          <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false" [dateFormat]="'jYYYY-jMM-jDD'" [input]="datepickerInputEnd"></ng-persian-datepicker>
        </div>
      </div>
       <div class="row">
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1">Customer Name	</label>
          <input [(ngModel)]="Filter_customer"  name="Filter_customer" type="text" class="form-control"  placeholder="Type here to search...">
        </div>
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1"> Receipt Number </label>
          <input [(ngModel)]="Filter_code"  name="Filter_customer" type="number" class="form-control"  placeholder="Type here to search...">
        </div>
      </div>

     <br/>
     <div class="row">
      <div  class="form-group col-md-6" >
        <button *ngIf="!Procssing" type="button" (click)="ReadData_Colleague(datepickerInputStart.value,datepickerInputEnd.value)" class="btn btn-info" style="margin-right: 5px;"><i class="fa  fa-search"></i> Search </button>
        <button *ngIf="Procssing" type="button"  class="btn btn-info" style="margin-right: 5px;"> Please wait...  <i class="fa fa-spin fa-spinner"></i> </button>
      </div>
     </div>
      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>Receipt Number</th>
              <th>Customer Name</th>
              <th>Contractor Name</th>
              <th>Request Subject</th>
              <th>Registration Date</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_Colleague
            | paginate
                    : {
                        id: 'DataList_ColleagueTable',
                        itemsPerPage: 50,
                        currentPage: page,
                        totalItems: (DataList_Colleague).length
                      }
            ">
             <td>{{DataList_Colleague.indexOf(item)+1}}</td>
             <td>{{item.code}}</td>
              <td>{{item.customerName}}</td>
              <td>{{item.contractName}} - {{item.contractCustomerName}} </td>
              <td>{{item.subject}} </td>
              <td>{{item.persianDate}} </td>

              <td>
                <div class="btn-group  " role="group" aria-label="Button group with nested dropdown">
                  <div *ngIf="!item.DeletingProccess" class="btn-group" role="group">
                      <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                          Actions
                      </button>
                      <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                        <a  style="cursor: pointer;" target="_blank"  href="{{item.pdf}}" class="dropdown-item" ><i class="fa fa-file-pdf-o"></i> PDF </a>

                      </div>
                  </div>

                  <div *ngIf="item.DeletingProccess" >
                    <img  src="assets/Loading.gif" style="width: 25px;" />
                  </div>
              </div>
              </td>

            </tr>
          </tbody>
        </table>
     </div>
    </div>
    <pagination-controls
     id="DataList_ColleagueTable"
     nextLabel="Next"
     previousLabel="Previous"
     (pageChange)="page = $event"
   ></pagination-controls>
  </div>
</div>
